import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { feesMapper } from "mappers";
import { merchantFeesService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetMerchantFeesQuery = ({ merchantId }: { merchantId: string }) => {
	const dispatch = useDispatch();

	return useQuery(
		[`getMerchantFees`, merchantId],
		() => merchantFeesService.getFees({ merchantId }),
		{
			select: (data: { [key: string]: any }) => feesMapper(data),
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
			enabled: !!merchantId,
		},
	);
};
export default useGetMerchantFeesQuery;
